(ns pfo.infobox (:require [pfo.state :as state]
                          [reagent.core :as reagent :refer [atom]]))

(def $ js/$)

(defn info-container [event user-data]
  (reset! state/infobox
    {:message user-data
     :eventPageX (.-pageX event)
     :eventPageY (.-pageY event)})
  (.stopPropagation event))

(defn infobox-hide []
  (.fadeOut ($ "#infobox") 400 (fn [] 
                                 (reset! state/infobox nil)
                                 (.css ($ "#infobox") (clj->js {"display" "block" "visibility" "hidden"})) )))

(defn infobox []
  (let [elem (atom nil)
        close-on-outside-click (fn [_]
                                  (when (= "visible" (.css ($ "#infobox") "visibility"))
                                    (infobox-hide)))]
    (reagent/create-class
      {:reagent-render
       (fn []
         [:div#infobox {:ref      #(reset! elem %)
                        :on-click #(.stopPropagation %)}
          [:a {:on-click #(infobox-hide)} "×"]
          [:ul
           (map (fn [[label entity]]
                  [:li {:key label} [:label (str label ": ")]
                   (if (= label "Email") [:a.email {:href (str "mailto:" entity )} entity]
                       [:span entity ])] ) (:message @state/infobox))]])
       :component-did-mount   (fn [_]
                                (.addEventListener js/document "click" close-on-outside-click))
       :component-will-unmount (fn [_]
                                 (.removeEventListener js/document "click" close-on-outside-click))
       :component-did-update (fn []
                               (.css ($ @elem) (clj->js {"visibility" "visible" "position" "absolute"}))
                               ;; For some reason, infobox doesn't appear on first click on a page when the below styles are
                               ;; set in the invocation above, hence the separation.
                               (.css ($ @elem) (clj->js {"top" (- (:eventPageY @state/infobox) (.outerHeight ($ @elem)))
                                                         "left" (- (:eventPageX @state/infobox) (.outerWidth ($ @elem)))})))})))
